import React, { useState, useEffect, useContext, useRef } from "react";
import {
  Modal,
  Button,
  Select,
  Input,
  Form,
  Table,
  Row,
  Col,
  Typography,
  Popconfirm,
} from "antd";
import { defaultOptions, EditableCell, EditableRow } from "./EditableCell";
import { getConvertedValue } from "utils/helpers";
import axios from "axios";
import API_KEY from "api/index";
import { DeleteFilled } from "@ant-design/icons";

const { Title } = Typography;
export default function Index({
  data,
  defaults,
  isVariantModalVisible,
  setIsVariantModalVisible,
  handleOkVariant,
  handleCancelVariant,
  variantData,
  activeProductId,
  currency,
  setCurrency,
  unit,
  form,
  setUnit,
  sizeUnit,
  setSizeUnit,
  collectionProductId,
  customAttrs,
  setIsSizeChanged,
}) {
  const [columns, setColumns] = useState([]);
  const [dataSource, setDataSource] = useState([]);
  const [saving, setSaving] = useState(false);
  const [attrId, setAttrId] = useState(null);
  const [isSizeChanged, setSizeChanged] = useState(false);
  const [isPriceChanged, setPriceChanged] = useState(false);
  useEffect(() => {
    if (
      variantData?.columns?.length > 0 &&
      Object.keys(variantData?.data_source).length > 0
    ) {
      mapData(variantData.data_source);
      createColumns(variantData.columns);
    }
  }, [variantData]);

  const staticCol = [
    {
      title: "Product ID",
      dataIndex: "productId",
      editable: false,
      width: 100,
    },
    {
      title: "test",
      dataIndex: "variantId",
      editable: false,
      width: "200px",
    },
  ];

  const createColumns = (data) => {
    setColumns([
      ...data.flatMap((item, index) => {
        if (item?.type === "price" && item?.is_internal === false) {
          return [
            {
              ...item,
              title: (
                <select
                  style={{
                    background: "transparent",
                    marginRight: 4,
                    borderStyle: "none",
                    outlineStyle: "none",
                    outline: "none",
                    wdith: 100,
                    padding: "0px 10px",
                  }}
                  onChange={(e) => {
                    handlePriceChange(
                      e?.target?.value,
                      `${item.name}_currency`
                    ); //bulk edit all columns
                  }}
                >
                  <option disabled selected value>
                    Currency
                  </option>
                  {defaultOptions.price.currency.map((unit, index) => (
                    <option key={index} value={unit}>
                      {unit}
                    </option>
                  ))}
                </select>
              ),
              dataIndex: `${item.name}_currency`,
              key: index,
              visible: item?.visible,
              editable: item?.attribute_id ? true : false,
              className: item?.color ? "light-cyan" : "light-yellow",
              width: 120,
            },
            {
              ...item,
              title: item?.name,
              dataIndex: item?.name,
              key: index + 1,
              visible: item?.visible,
              editable: item?.attribute_id ? true : false,
              className: item?.color ? "light-cyan" : "light-yellow",
            },
            {
              ...item,
              title: (
                <select
                  style={{
                    background: "transparent",
                    marginRight: 4,
                    borderStyle: "none",
                    outlineStyle: "none",
                    outline: "none",
                    width: 100,
                    padding: "0px 10px",
                  }}
                  onChange={(e) => {
                    handlePriceChange(e?.target?.value, `${item.name}_unit`); //bulk edit all columns
                  }}
                >
                  <option disabled selected value>
                    Unit
                  </option>
                  {defaultOptions.price.unit.map((unit, index) => (
                    <option key={index} value={unit}>
                      {unit}
                    </option>
                  ))}
                </select>
              ),
              dataIndex: `${item.name}_unit`,
              key: index + 2,
              visible: item?.visible,
              editable: item?.attribute_id ? true : false,
              className: item?.color ? "light-cyan" : "light-yellow",
              width: 120,
            },
          ];
        } else if (item?.type === "size" && item?.is_internal === false) {
          return [
            {
              ...item,
              title: item?.name,
              dataIndex: item?.name,
              key: index,
              visible: item?.visible,
              editable: item?.attribute_id ? true : false,
              className: item?.color ? "light-cyan" : "light-yellow",
              width: 300,
            },
            {
              ...item,
              title: (
                <select
                  style={{
                    background: "transparent",
                    marginRight: 4,
                    borderStyle: "none",
                    outlineStyle: "none",
                    outline: "none",
                    // minWidth: 100,
                    padding: "0px 10px",
                  }}
                  onChange={(e) => {
                    handleSizeUnitChange(e?.target?.value, item.name); //bulk edit all columns
                  }}
                >
                  <option disabled selected value>
                    Unit
                  </option>
                  {["cms", "inches"].map((unit, index) => (
                    <option key={index} value={unit}>
                      {unit}
                    </option>
                  ))}
                </select>
              ),
              dataIndex: `${item.name}_unit`,
              key: index + 1,
              visible: item?.visible,
              editable: item?.attribute_id ? true : false,
              className: item?.color ? "light-cyan" : "light-yellow",
              width: 120,
            },
          ];
        } else if (item?.name === "Product ID") {
          return {
            ...item,
            title: item?.name,
            dataIndex: item?.name,
            key: index,
            visible: item?.visible,
            editable: item?.attribute_id ? true : false,
            className: item?.color ? "light-cyan" : "light-yellow",
            width: 150,
            fixed: "left",
          };
        } else if (item?.name === "Category") {
          return {
            ...item,
            title: item?.name,
            dataIndex: item?.name,
            key: index,
            visible: item?.visible,
            editable: item?.attribute_id ? true : false,
            className: item?.color ? "light-cyan" : "light-yellow",
            // minWidth: 140,
            fixed: "left",
          };
        } else {
          return {
            ...item,
            title: item?.name,
            dataIndex: item?.name,
            key: index,
            visible: item?.visible,
            editable: item?.attribute_id ? true : false,
            className: item?.color ? "light-cyan" : "light-yellow",
            width: 180,
          };
        }
      }),
    ]);
  };

  const mapData = (data) => {
    if (data) {
      var productData = [];

      for (let productId in data) {
        let product = data[productId];

        const rowData = product.flatMap((item, index) => {
          //WIP - need to check condition for price type & internal || disable
          if (item?.type === "price" && item?.name !== "Product Cost") {
            return [
              {
                product_id: productId,
                [item?.name]: item?.value,
              },
              {
                product_id: productId,
                [`${item?.name}_currency`]: item?.sub_columns.filter(
                  (item) => item?.name === "currency"
                )?.[0]?.value,
              },
              {
                product_id: productId,
                [`${item?.name}_unit`]: item?.sub_columns.filter(
                  (item) => item?.name === "unit"
                )?.[0]?.value,
              },
            ];
          } else if (item.type == "size") {
            let composite = item[item.name] || {};
            return [
              {
                product_id: productId,
                [`${item?.name}`]: {
                  length: composite.length,
                  width: composite.width,
                  height: composite.height,
                },
              },
              {
                product_id: productId,
                [`${item?.name}_unit`]: composite.unit,
              },
            ];
          } else {
            return {
              product_id: productId,
              [item?.name]: item?.value,
              productData: product,
            };
          }
        });

        productData.push(Object.assign({}, ...rowData));
      }

      setDataSource(productData);
    }
  };

  const components = {
    body: {
      row: EditableRow,
      cell: EditableCell,
    },
  };

  const handlePriceChange = (value, key) => {
    setDataSource((state) => {
      return state.map((item) => {
        return {
          ...item,
          [key]: value,
        };
      });
    });
    setPriceChanged(true);
  };

  const filterdColumns =
    columns.length > 0 && columns.filter((item) => item.visible === true);

  const newColumns =
    filterdColumns.length > 0 &&
    filterdColumns.map((col) => {
      if (!col.editable) {
        return col;
      }

      return {
        ...col,
        onCell: (record) => ({
          record,
          editable: col.editable,
          dataIndex: col.dataIndex,
          title: col.title,
          handleSave: handleSave,
          type: col?.type,
          defaults: defaults,
          saving: saving,
          setSaving: setSaving,
          isSizeChanged: isSizeChanged,
          setSizeChanged: setSizeChanged,
          isPriceChanged: isPriceChanged,
          setPriceChanged: setPriceChanged,
        }),
      };
    });
  const handleSave = (row, dataIndex, type) => {
    const newData = [...dataSource];
    const index = newData.findIndex(
      (item) => row.product_id === item.product_id
    );
    const item = newData[index];
    newData.splice(index, 1, { ...item, ...row });
    setDataSource(newData);
  };

  // const updateCurrencyOrUnit = (attributeId, data) => {
  //   for (let i = 0; i < dataSource.length; i++) {
  //     const item = dataSource[i];
  //     const keys = Object.keys(item);

  //     for (let j = 0; j < keys.length; j++) {
  //       const key = keys[j];

  //       if (item[key] === "id" && key.includes(`${attributeId}`)) {
  //         const editedValue = item[`${key.split(":")?.[0]}:${attributeId}`];
  //         const attrValueId = key.split("/")[1];

  //         let compositeValue = {
  //           currency: data?.currency ? data?.currency : editedValue?.[0],
  //           unit: data?.unit ? data?.unit : editedValue?.[2],
  //         };

  //         let requestPayloadForPatch = {
  //           id: attrValueId,
  //           attribute_id: attributeId,
  //           values: editedValue?.[1],
  //           composite: compositeValue,
  //         };

  //         if (attrValueId) {
  //           setSaving(true);
  //           API_KEY.URL.patch(
  //             `${API_KEY.path.attribute_values}/${attrValueId}`,
  //             requestPayloadForPatch
  //           )
  //             .then((res) => {
  //               setSaving(false);
  //             })
  //             .catch((err) => {
  //               setSaving(false);
  //             });
  //         }
  //       }
  //     }
  //   }
  // };

  const handleSizeUnitChange = (value, key) => {
    setDataSource((state) => {
      return state.map((item) => {
        let oldValues = item[key];
        let oldUnit = item[`${key}_unit`] || "";
        if (oldUnit && oldUnit != value) {
          Object.keys(oldValues).map(function (current, index) {
            oldValues[current] = getConvertedValue(oldValues[current], value);
          });
        }

        return {
          ...item,
          [key]: { ...oldValues, unit: value },
          [`${key}_unit`]: value,
        };
      });
    });
    setSizeChanged(true);
  };

  // useEffect(() => {
  //   if (attrId && dataSource.length > 0) {
  //     updateCurrencyOrUnit(attrId, { unit, currency });
  //   }
  // }, [attrId, dataSource, unit, currency]);

  const columnsObj = columns.map((col) => {
    if (!col.editable) {
      return col;
    }

    return {
      ...col,
      onCell: (record) => ({
        record,
        editable: col.editable,
        dataIndex: col.dataIndex,
        title: col.title,
        type: col.type,
        defaultValue: col.defaultValue,
        handleSave: handleSave,
        variantData: variantData,
        collectionProductId: collectionProductId,
        defaults: defaults,
        saving: saving,
        setSaving: setSaving,
        isSizeChanged: isSizeChanged,
        setSizeChanged: setSizeChanged,
        isPriceChanged: isPriceChanged,
        setPriceChanged: setPriceChanged,
      }),
    };
  });

  return (
    <Modal
      visible={isVariantModalVisible}
      onOk={handleOkVariant}
      onCancel={handleCancelVariant}
      footer={null}
      width={"80%"}
      centered
      bodyStyle={{ padding: "2em" }}
    >
      <Row>
        <Col>
          <Title level={4}>Variants available {activeProductId}</Title>
        </Col>
        {/* <Col>
          {saving ? (
            "Saving..."
          ) : (
            <IoCloudDoneOutline size={20} style={{ margin: 3 }} />
          )}
        </Col> */}
      </Row>

      <Row>
        <Col span={24}>
          <Table
            components={components}
            rowClassName={() => "editable-row"}
            bordered
            dataSource={dataSource}
            columns={newColumns}
            pagination={false}
            // style={{height:400,overflowX:'scroll'}}
            scroll={{ x: "max-content", y: "auto" }}
            // sticky
          />
        </Col>
      </Row>
    </Modal>
  );
}
